<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <div class='sub-content' > <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-tree-list
        ref="refDivision"
        :height='gridHeight'
        :data-source="divisionList"
        :autoExpandAll='true'
        :show-borders="true" :showRowLines = 'true'
        :column-auto-width="true"
        :hover-state-enabled = "true"
        key-expr="부서코드"
        parent-id-expr="상위부서코드"
        :focused-row-enabled="true"
        :allow-column-resizing="true"
        column-resizing-mode="nextColumn"
        @init-new-row="onInitNewRow"
        @row-inserted='onRowInserted'
        @row-updated='onRowUpdated'
        @row-removed='onRowRemoved'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxEditing
          :allow-adding="(userInfo.permission & crudAllow) > 0"
          :allow-updating="(userInfo.permission & crudAllow) > 0"
          :allow-deleting="(userInfo.permission & crudAllow) > 0"
          :use-icons="true"
          mode="row"
        />
        <dx-column
          data-field="부서명"
          caption="부서명"
          :allow-sorting="true"
          sort-order="asc"
        />
        <dx-column
          data-field="생산반여부"
          caption="생산반여부"
          :allow-sorting="false"
        />
        <dx-column
          data-field="사용유무"
          caption="사용유무"
          :allow-sorting="false"
        />
        <DxColumn
          caption="등록일"
          :allowEditing='false'
          data-field="createtime"
          dataType= 'date'
          format='yyyy-MM-dd'
          alignment='center'>
        </DxColumn>
        <dx-column
          data-field="createid"
          :allowEditing='false'
          caption="등록ID"
          :allow-sorting="false"
        />
        <DxColumn
          caption="수정일"
          :allowEditing='false'
          data-field="updatetime"
          dataType= 'date'
          format='yyyy-MM-dd'
          alignment='center'>
        </DxColumn>
         <dx-column
          data-field="updateid"
          :allowEditing='false'
          caption="수정ID"
          :allow-sorting="false"
        />
        <dx-column
          data-field="부서코드"
          :allowEditing='false'
          caption="부서코드"
          :allow-sorting="false"
        />
        <DxScrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <DxPaging :enabled="false"/>
      </dx-tree-list>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import { DxTreeList, DxColumn, DxSearchPanel, DxScrolling, DxPaging, DxEditing } from 'devextreme-vue/tree-list'

export default {
  name: 'login',
  data: function () {
    return {
      crudAllow: ConstDef.CRUD_ALLOW_경영_생산,
      userInfo: this.$store.getters.getUserInfo,
      isLoading: false,
      selectedIndex: 0,
      tabs: [
        {
          title: '부서관리'
        }
      ],
      divisionList: null,
      gridHeight: null
    }
  },
  components: {
    Loading,
    DxTreeList,
    DxColumn,
    DxTabPanel,
    DxSearchPanel,
    DxScrolling,
    DxPaging,
    DxEditing
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.refreshDivisionList()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onInitNewRow (e) {
      console.log(e)
      // if (e.data.상위부서코드 === '0' || e.data.상위부서코드 === 0) {
      //   e.data.상위부서코드 = 'null'
      // }
      e.data.사용유무 = true
      e.data.생산반여부 = false
      e.data.부서코드 = 'D0000'
    },
    onRowInserted (row) {
      console.log(row)
      row.data.updatetime = row.data.createtime = AppLib.getToday()
      row.data.updateid = row.data.createid = this.userInfo.userId
      if (row.data.상위부서코드 === '0' || row.data.상위부서코드 === 0) {
        row.data.상위부서코드 = null
      }
      this.$_sp.runInsertAndUpdateIdSqlProc('부서정보', ['부서코드'], ['seqId'], 'seqId', '부서코드', 'D', AppLib.deleteUnderlineKey(row.data))
        .then((data) => {
          let newData = this.$_sp.MakeModel(data)[0]
          row.data.seqId = newData.seqId
          row.data.부서코드 = newData.부서코드
          this.$refs.refDivision.instance.refresh()
          this.$snotify.info('추가되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowRemoved (row) {
      console.log(row)
      let child = this.$_.findWhere(this.divisionList, { 상위부서코드: row.data.부서코드 })
      if (child !== undefined) {
        this.onRowRemoved({ data: child })
      }
      this.$_sp.runDeleteSqlProc('부서정보', [{ 부서코드: row.data.부서코드 }])
        .then((data) => {
          let index = this.$_.findIndex(this.divisionList, { 부서코드: row.data.부서코드 })
          if (index >= 0) {
            this.divisionList.splice(index, 1)
          }
        })
    },
    onRowUpdated (row) {
      console.log(row)
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userId
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('부서정보', ['부서코드'], ['seqId'], array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
    },
    refreshDivisionList () {
      this.isLoading = true

      this.$_sp.runNoEncodeFindSqlProc('부서정보', null)
        .then((data) => {
          this.divisionList = this.$_.sortBy(this.$_sp.MakeModel(data), '부서코드')
          this.gridHeight = (screen.height - 250) * 0.95
          console.log(this.divisionList)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.ff{
  text-align: center;
}
</style>
